export const testTypes = {
  unmoderated: {
    label: 'Unmoderated - Speak aloud',
    amount: 10,
  },
  moderated: {
    label: 'Moderated interview - Live conversation',
    amount: {
      30: 30,
      60: 60,
      90: 90,
      120: 120,
    },
  },
  card_sort: {
    label: 'Card sort',
    amount: 2,
  },
  tree_test: {
    label: 'Tree test',
    amount: 2,
  },
  survey: {
    label: 'Survey',
    amount: 1,
  },
};
